// Arabic blog data — five posts translated to match the English catalogue.
// Slugs match the English blog so hreflang pairs cleanly.
export const BLOG_INTRO_AR =
  "ملاحظات من فريقنا — عن قانون حماية البيانات، الذكاء الاصطناعي، شراء البرمجيات، وتشغيل المنصات في عُمان. مكتوبة لمن يتخذ القرارات.";

export const BLOG_POSTS_AR = [
  {
    slug: "oman-pdpl-compliance-checklist-2026",
    title: "قائمة التحقق من الامتثال لقانون حماية البيانات الشخصية في عُمان لعام 2026",
    tag: "عُمان والامتثال",
    date: "2026-02-05",
    readTime: "٩ دقائق قراءة",
    dek: "القانون نافذ بالكامل منذ 5 فبراير 2026. ستة التزامات هي الأهم، ومعظم المؤسسات تفشل في الدليل، لا في النية.",
    inShort: [
      "القانون نافذ بالكامل منذ 5 فبراير 2026",
      "ستة التزامات هي الأهم: الموافقة، الإشعارات، الطلبات، مسؤول الحماية، النقل، والخروقات",
      "معظم المؤسسات تفشل في الدليل، لا في النية",
    ],
    intro:
      "صدر قانون حماية البيانات الشخصية في عُمان بموجب المرسوم السلطاني رقم 6/2022. ودخلت لائحته التنفيذية الصادرة بموجب القرار الوزاري رقم 34/2024 حيز التنفيذ الكامل اعتبارًا من 5 فبراير 2026، تحت إشراف وزارة النقل والاتصالات وتقنية المعلومات. معظم من نتحدث معهم لا يقاومون القانون. هم ببساطة لا يعرفون أي أجزاء منه تنطبق عليهم، أو كيف يثبتون الامتثال.",
    sections: [
      { h2: "1. موافقة موثقة لا مفترضة", body: "صندوق اختيار وحده لا يكفي. تحتاجون سجلًا لما تمت الموافقة عليه، ومتى، وبأي نسخة من الإشعار." },
      { h2: "2. إشعار خصوصية يمكن قراءته فعليًا", body: "أخبروا الناس بما تجمعونه ولماذا، ومع من تشاركونه، وكيف يمارسون حقوقهم. باللغتين." },
      { h2: "3. عملية للرد خلال 45 يومًا", body: "دون مقابل. من يملك هذا في مؤسستكم؟ إن لم يكن معروفًا، فالجواب سيتأخر." },
      { h2: "4. مسؤول حماية بيانات معلن", body: "الاشتراط واسع، وتُفضَّل الوزارة أن يكون مقيمًا في عُمان." },
      { h2: "5. ضبط نقل البيانات خارج السلطنة", body: "يتطلب موافقة وتقييمًا لمستوى الحماية في الدولة المستقبِلة، وموافقة الوزارة للبيانات الشخصية الحساسة." },
      { h2: "6. عملية إبلاغ عن الخروقات تعمل بساعة", body: "إبلاغ الوزارة خلال 72 ساعة إن كان هناك خطر على حقوق الأفراد." },
      { h2: "ما يعنيه هذا لكم", body: "النمط متكرر — نوايا جيدة، بلا دليل. أصلحوا مشكلة الدليل ويتبعها الباقي." },
    ],
  },
  {
    slug: "does-your-data-have-to-stay-in-oman",
    title: "هل يجب أن تبقى بياناتكم داخل عُمان؟",
    tag: "عُمان والامتثال",
    date: "2026-01-28",
    readTime: "٧ دقائق قراءة",
    dek: "لا. القانون لا يمنع النقل خارج السلطنة، لكنه يشترط موافقة وتقييمًا للحماية. البيانات الحساسة تحتاج موافقة الوزارة.",
    inShort: [
      "القانون لا يمنع النقل خارج السلطنة",
      "يتطلب موافقة وتقييمًا لحماية الدولة المستقبِلة",
      "البيانات الحساسة المعالجة خارج عُمان تحتاج موافقة الوزارة",
    ],
    intro:
      "هذا السؤال الأكثر تكرارًا، والإجابة غالبًا عكس ما يتوقعه الناس. قانون حماية البيانات الشخصية في عُمان لا يشترط بقاء البيانات داخل السلطنة. من يخبركم بذلك إما مخطئ أو يبيعكم شيئًا.",
    sections: [
      { h2: "الإجابة المختصرة", body: "النقل يتطلب موافقة وتقييمًا لمستوى الحماية في الدولة المستقبِلة. البيانات الحساسة المعالجة خارج عُمان تحتاج موافقة الوزارة." },
      { h2: "فلماذا يحتفظ البعض بالبيانات محليًا؟", body: "لأن للعملية تكلفة. كل نقل يعني تقييمًا. كل نقل لبيانات حساسة يعني طلب تصريح. الاحتفاظ محليًا يبسّط ذلك." },
      { h2: "الخطأ الذي يقع فيه الجميع تقريبًا", body: "قلة قليلة تتخذ هذا القرار بوعي. يرثنه من اختيار مطوّر سابق قبل سنوات، دون تسجيله." },
      { h2: "ما يعنيه هذا لكم", body: "ابدأوا بخريطة بيانات، ثم قرروا عن وعي." },
    ],
  },
  {
    slug: "what-software-costs-in-oman",
    title: "كم تكلّف البرمجيات في عُمان",
    tag: "البرمجيات والمنتج",
    date: "2026-01-15",
    readTime: "٨ دقائق قراءة",
    dek: "أداة داخلية بسيطة تبدأ من آلاف الريالات القليلة. منصة بتطبيقات جوال تصل لعشرات الآلاف. التكاملات والنطاق غير الواضح يحرّكان الرقم أكثر من الميزات.",
    inShort: [
      "أداة داخلية بسيطة تبدأ من آلاف الريالات القليلة",
      "منصة بتطبيقات جوال تصل لعشرات الآلاف",
      "التكاملات والنطاق غير الواضح يحرّكان الرقم أكثر من الميزات",
    ],
    intro: "الرقم الذي تسمعونه يعتمد على من تسألون. سنكون واضحين هنا بأرقام واقعية.",
    sections: [
      { h2: "ما يحرّك الرقم", body: "عدد أنواع المستخدمين، التكاملات، الجوال، ووضوح المتطلبات. المتطلبات الغامضة هي أغلى بند في الفاتورة." },
      { h2: "نطاقات تقريبية", body: "أداة داخلية 6-10 أسابيع · منصة أعمال 3-5 أشهر · منصة بتطبيقات عملاء وسائقين 4-6 أشهر." },
      { h2: "التكاليف التي يُغفلها الناس", body: "الاستضافة الشهرية، الدعم، رسوم المتاجر، الترجمة، والتدريب." },
      { h2: "ما يعنيه هذا لكم", body: "اطلبوا تفصيلًا لكل وحدة، لا رقمًا واحدًا." },
    ],
  },
  {
    slug: "how-to-choose-a-software-development-company-in-oman",
    title: "كيف تختارون شركة تطوير برمجيات في عُمان",
    tag: "البرمجيات والمنتج",
    date: "2026-01-08",
    readTime: "٧ دقائق قراءة",
    dek: "اطلبوا رؤية نظام يعمل فعليًا، لا تصميمًا. احصلوا على ملكية الكود كتابيًا قبل التوقيع. محادثة الدعم أهم من محادثة البناء.",
    inShort: [
      "اطلبوا رؤية نظام يعمل فعليًا، لا تصميمًا",
      "احصلوا على ملكية الكود كتابيًا قبل التوقيع",
      "محادثة الدعم أهم من محادثة البناء",
    ],
    intro: "قرار الشركة أهم من قرار الميزات. الميزات يمكن تغييرها؛ الشراكة أصعب.",
    sections: [
      { h2: "أسئلة تستحق أن تُسأل", body: "\"هل يمكنني رؤية شيء تعمل عليه الآن؟\" · \"من سيكتب هذا فعليًا؟\" · \"ماذا يحدث عند الاختلاف على النطاق؟\"" },
      { h2: "إجابات يجب أن تُقلقكم", body: "\"يمكننا البدء الاثنين\" قبل تحديد النطاق. سعر واحد بلا تفصيل." },
      { h2: "احصلوا على ملكية الكود كتابيًا", body: "هذا البند الذي يتخطاه الناس ثم يندمون عليه بعد سنة." },
      { h2: "ما يعنيه هذا لكم", body: "اقضوا وقتًا أطول في محادثة الدعم من محادثة البناء." },
    ],
  },
  {
    slug: "building-a-risk-register-your-auditor-accepts",
    title: "بناء سجل مخاطر يقبله المدقق",
    tag: "الحوكمة والمخاطر",
    date: "2025-12-18",
    readTime: "٦ دقائق قراءة",
    dek: "سجل بلا مالكين مسمّين هو قائمة، لا سجل. التقييم الأصلي والمتبقي هو ما يُثبت أن الضابط يعمل. معظم التدقيقات تفشل في إثبات الاختبار.",
    inShort: [
      "سجل بلا مالكين مسمّين هو قائمة، لا سجل",
      "التقييم الأصلي والمتبقي هو ما يُثبت أن الضابط يعمل",
      "معظم التدقيقات تفشل في إثبات الاختبار، لا في السجل نفسه",
    ],
    intro: "معظم سجلات المخاطر التي نراها هي جداول بيانات بلا مالكين. المدقق لا يقبلها.",
    sections: [
      { h2: "خمسة أمور تجعل السجل موثوقًا", body: "مالك مسمّى، تاريخ مراجعة، تقييم أصلي ومتبقٍّ، ضوابط مرتبطة، ودليل اختبار." },
      { h2: "ما يعنيه هذا لكم", body: "ابدأوا أصغر مما تظنون. عشرون مخاطرة بمالكين حقيقيين أفضل من مئتين مهملة." },
    ],
  },
];

export const BLOG_TAGS_AR = ["عُمان والامتثال", "البرمجيات والمنتج", "الذكاء الاصطناعي", "الحوكمة والمخاطر", "اللوجستيات والتجارة الإلكترونية"];

export function getBlogPostAr(slug) { return BLOG_POSTS_AR.find((p) => p.slug === slug); }
